/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { ic_videocam } from "react-icons-kit/md/ic_videocam";
import Icon from "react-icons-kit";

import { Text } from "UpduoLibrary";
import { upduoLighterGray, upduoSecondaryOrange } from "config/UpduoColors";
import CountdownTimer from "UpduoLibrary/CountdownTimer";
import { View } from "react-native";
import { getSummitState, SummitState } from "config/Utilities";

export default function SummitStartCountdown({
  now,
  startDate,
  endDate,
  color,
}: {
  now: Date;
  startDate: Date;
  endDate: Date;
  color: string;
}) {
  const state = getSummitState({ now, startDate, endDate });
  const style = {
    lineHeight: 16,
    fontSize: 12,
    borderRadius: 4,
    paddingTop: 2,
    paddingBottom: 2,
    paddingHorizontal: 4,
    alignSelf: "flex-start" as any,
    marginBottom: 24,
    textTransform: "uppercase",
    letterSpacing: ".1rem" as any,
  };

  switch (state) {
    case SummitState.NOT_STARTED: {
      return (
        <CountdownTimer
          currentTime={now}
          countdownEnd={startDate}
          color={color}
          style={{
            marginBottom: 24,
            alignSelf: "flex-start",
          }}
        />
      );
    }
    case SummitState.COMPLETED: {
      const text = "Past event";
      return (
        <View
          style={[
            style,
            {
              backgroundColor: upduoLighterGray,
            },
          ]}
        >
          <Text
            style={{
              color: "white",
              fontWeight: "bold",
            }}
          >
            {text}
          </Text>
        </View>
      );
    }
    case SummitState.ACTIVE: {
      const text = "Live";
      return (
        <View
          style={[
            style,
            {
              backgroundColor: upduoSecondaryOrange,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            },
          ]}
        >
          <Text
            style={{
              color: "white",
            }}
          >
            <Icon
              icon={ic_videocam}
              size={23}
              style={{ verticalAlign: "middle", marginRight: 4 }}
            />
          </Text>
          <Text
            style={{
              color: "white",
              fontWeight: "bold",
            }}
          >
            {text}
          </Text>
        </View>
      );
    }
  }
}
